/*eslint-disable */
import {bus} from '@/main';
export default {
  name: 'reason-show-popup',
  components: {},
  props: ['reason'],
  data () {
    return {
      reasonData:''
    }
  },
  computed: {

  },
  mounted () {
    this.reasonData = this.reason
  },
  methods: {
    blurbTextPopupClosed(){
      bus.$emit('reasonShowStateBus', false);
      document.body.classList.remove('body_right_scroll_remove')
    }
  }
}